import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { TextField, useMediaQuery } from '@material-ui/core';
import { Values } from '../../../../values/Values';
import clsx from 'clsx';
import DialogContent from '@material-ui/core/DialogContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { useTheme } from '@material-ui/styles';
import { TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import { putEmpresa } from '../../../../services/EmpresaService';
import { useStyles } from './ConfiguracoesGeraisStyles';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function ConfiguracoesGerais(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    empresa,
    setEmpresa,
    setLoading,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
  } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [refreshState, setRefreshState] = useState(new Date());
  const [modoEdicao, setModoEdicao] = useState(false);
  const [erroRazaoSocial, setErroRazaoSocial] = useState(false);
  const [erroNomeFantasia, setErroNomeFantasia] = useState(false);
  const [erroCnpj, setErroCnpj] = useState(false);
  const [erroEmail, setErroEmail] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  async function salvarEmpresa(event) {
    try {
      event.preventDefault();
      setLoading(true);
      if (!empresa.razaoSocial) {
        setErroRazaoSocial(true);
        setLoading(false);
        return;
      }
      if (!empresa.nomeFantasia) {
        setErroNomeFantasia(true);
        setLoading(false);
        return;
      }
      if (!empresa.cnpj) {
        setErroCnpj(true);
        setLoading(false);
        return;
      }
      if (!empresa.email) {
        setErroEmail(true);
        setLoading(false);
        return;
      }
      let empresaPut = {
        idEmpresa: empresa.idEmpresa,
        razaoSocial: empresa.razaoSocial,
        nomeFantasia: empresa.nomeFantasia,
        cnpj: empresa.cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', ''),
        email: empresa.email
      };
      setOpen(false);
      let retorno = await putEmpresa(empresaPut);
      if (retorno.isSuccess) {
        setLoading(false);
        setMessageSnack('Dados atualizados com sucesso.');
        setTypeSnack('success');
        setShowMessageSnack(true);
      }
      else {
        setLoading(false);
        setMessageSnack(retorno.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
        setOpen(true);
      }
      setModoEdicao(false);
      setEmpresa({
        cnpj: '',
        email: '',
        horaEmpresa: undefined,
        idEmpresa: '',
        nomeFantasia: '',
        razaoSocial: '',
      });
    }
    catch (e) {
      setLoading(false);
      setMessageSnack(e.toString());
      setTypeSnack('error');
      setShowMessageSnack(true);
      setOpen(true);
      setModoEdicao(false);
    }
  }



  return (

      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={!isDesktop}
        TransitionComponent={Transition}
        className={clsx({
            [classes.root]: true
          }
        )}
      >
        <AppBar className={classes.appBar} color={'transparent'} variant={'outlined'}>
          <Toolbar>
            <Typography variant="h6" className={classes.title} >Configurações gerais</Typography>
            <IconButton edge="end" color="primary" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao]: true
                })}
              >
                Aqui você encontra as informações referente ao Clube de Tiro Garanhuns. Para editar essas informações
                basta clicar no botão EDITAR e preencher os campos abaixo. Ao finalizar a edição, clique no botão SALVAR
                para manter as alterações.
              </Typography>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                label="Razão Social"
                variant="outlined"
                fullWidth
                margin='dense'
                helperText='Informe a razão social do clube.'
                value={empresa.razaoSocial}
                disabled={!modoEdicao}
                error={erroRazaoSocial}
                onChange={(e) => {
                  if(!e.target.value) {
                    setErroRazaoSocial(true);
                  }
                  else {
                    setErroRazaoSocial(false);
                  }
                  empresa.razaoSocial = e.target.value;
                  setEmpresa(empresa);
                  setRefreshState(new Date());
                }}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                label="Nome Fantasia"
                variant="outlined"
                fullWidth
                margin='dense'
                helperText='Informe o nome fantasia do clube.'
                value={empresa.nomeFantasia}
                disabled={!modoEdicao}
                error={erroNomeFantasia}
                onChange={(e) => {
                  if(!e.target.value) {
                    setErroNomeFantasia(true);
                  }
                  else {
                    setErroNomeFantasia(false);
                  }
                  empresa.nomeFantasia = e.target.value;
                  setEmpresa(empresa);
                  setRefreshState(new Date());
                }}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <InputMask
              mask={'99.999.999/9999-99'}
              value={empresa.cnpj}
              disabled={!modoEdicao}
              onChange={(e) => {
                if(!e.target.value) {
                  setErroCnpj(true);
                }
                else {
                  setErroCnpj(false);
                }
                empresa.cnpj = e.target.value;
                setEmpresa(empresa);
                setRefreshState(new Date());
              }}
            >
              {
                (inputProps) =>
                  <TextField
                    fullWidth
                    label="CNPJ"
                    helperText="Informe o CNPJ do clube."
                    margin="dense"
                    name="cnpj"
                    onChange={inputProps.onChange}
                    onBlur={inputProps.onBlur}
                    variant="outlined"
                    disabled={inputProps.disabled}
                    error={erroCnpj}
                  />
              }
            </InputMask>
            </Grid><Grid
            item
            md={12}
            xs={12}
          >
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              margin='dense'
              helperText='Informe o email para contato do clube.'
              value={empresa.email}
              type={'email'}
              disabled={!modoEdicao}
              error={erroEmail}
              onChange={(e) => {
                if(!e.target.value) {
                  setErroEmail(true);
                }
                else {
                  setErroEmail(false);
                }
                empresa.email = e.target.value;
                setEmpresa(empresa);
                setRefreshState(new Date());
              }}
            />
          </Grid>
          </Grid>
        </DialogContent>
        <DialogActions

        >
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={10}
              xs={12}

            >
            </Grid>
            {
              modoEdicao &&
              <Grid
                item
                md={12}
                xs={12}
                className={clsx({
                  [classes.gridBotaoSalvar]: true
                })}
              >
                <Button
                  fullWidth
                  variant={'contained'}
                  color={'primary'}
                  onClick={e => salvarEmpresa(e)}
                >
                  SALVAR
                </Button>
              </Grid>
            }
            {
              !modoEdicao &&
              <Grid
                item
                md={12}
                xs={12}
                className={clsx({
                  [classes.gridBotaoSalvar]: true
                })}
              >
                <Button
                  fullWidth
                  variant={'outlined'}
                  onClick={e => {
                    e.preventDefault();
                    setModoEdicao(true);
                  }}
                >
                  EDITAR
                </Button>
              </Grid>
            }

          </Grid>
        </DialogActions>

      </Dialog>
  );
}

export default ConfiguracoesGerais;
